import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { FireStorageService } from '../services/storage.service';

@Pipe({ name: 'getStorageURL', pure: false })
export class GetStorageURLPipe implements PipeTransform {
  private value?: string;
  private response = '';

  constructor(
    private _ref: ChangeDetectorRef,
    private storage: FireStorageService
  ) {}

  transform(value: string): string {
    if (value != this.value) {
      this.value = value;
      this.storage
        .getDownloadURL(value)
        .then((url) => {
          this.response = url;
          this._ref.markForCheck();
        })
        .catch((err) => console.warn(err));
    }
    return this.response;
  }
}
